import { Component } from 'preact'
import Panel from '../../control-components/panel'
import ContentCurationManager from '../content-curation/ContentCurationManager'
import axios from 'axios'

interface RecommendationsWidgetProps {
  content: Content
  onChange: (state: {
    curatedTopics: number[]
  }) => void
}

interface Content {
  curatedTopics: number[]
  isActive?: boolean
}

export interface CuratedTopic {
  id: number
  type: 'question' | 'article' | 'answer' | 'discussion' | 'idea'
  title: string
  url: string
  image: null | string
  author: {
    id: number
    name: string
    url: string
    avatar: string
  }
}

interface State {
  curatedTopics: CuratedTopic[]
}

export class RecommendationsWidgetConfigurator extends Component<RecommendationsWidgetProps, State> {
  constructor () {
    super()
    this.state = {
      curatedTopics: []
    }
    this.setValue = this.setValue.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }

  async componentDidMount() {
    if (this.props.content.curatedTopics.length === 0) {
      return
    }
    const { data } = await axios.get('/contentCuration/getTopics', {
      params: {
        topicIds: this.props.content.curatedTopics
      }
    })
    this.setState({ curatedTopics: data.content })
  }

  onChangeSend () {
    this.props.onChange({
      curatedTopics: this.state.curatedTopics.map(topic => topic.id)
    })
  }

  setValue (key: keyof State, value: State[keyof State]) {
    if (key === 'curatedTopics' && value instanceof Array) {
      this.setState({ [key]: value }, this.onChangeSend)
    }
  }

  shouldComponentUpdate (nextProps: RecommendationsWidgetProps, nextState: State) {
    return this.state !== nextState ||
      this.props.content.curatedTopics !== nextProps.content.curatedTopics ||
      this.props.content.isActive !== nextProps.content.isActive
  }

  render () {
    return (
      <div id='contentCurationManager'>
        <ContentCurationManager
          searchPlaceholder='Search for topics or enter a topic URL'
          onUpdate={this.setValue}
          showTitle={false}
          {...this.state}
        />
      </div>
    )
  }
}

interface PanelProps extends RecommendationsWidgetProps {
  dragHandle: JSX.Element
  switcher: JSX.Element
}

const HomepageContentCurationManagerPanel = (props: PanelProps) => {
  return (
    <Panel
      collapsible
      customClass='homepage-widget'
      title={<div className='qa-contentcuration-panel panel-title-with-switch'>
        <div className='homepage-reorderable-panel-title'>
          {props.dragHandle}
          <span>Recommendations</span>
        </div>
        {props.switcher}
      </div>}
    >
      <RecommendationsWidgetConfigurator {...props} />
    </Panel>
  )
}

export default HomepageContentCurationManagerPanel
